import { RepaymentPolicyStatus } from 'shared/models/repayments'
import styled, { css } from 'styled-components'

import {
  cyanD1,
  informationL1,
  kellyGreenD1,
  lightgreye3,
  marigoldOrange,
  midGray,
  paleyellow,
  success,
} from '../../theme/colors'

export const PolicyStatusBadge = styled.div<{ $status?: RepaymentPolicyStatus }>`
  padding: 5px 10px 4px;
  border-radius: 3px;
  white-space: nowrap;

  ${(p) => {
    switch (p.$status) {
      case RepaymentPolicyStatus.ACTIVE:
        return css`
          color: ${kellyGreenD1};
          background-color: ${success};
        `
      case RepaymentPolicyStatus.DRAFT:
        return css`
          color: ${cyanD1};
          background-color: ${informationL1};
        `
      case RepaymentPolicyStatus.PAUSED:
        return css`
          color: ${marigoldOrange};
          background-color: ${paleyellow};
        `
      case RepaymentPolicyStatus.STOP_BILLING_AND_COLLECTION:
        return css`
          color: ${marigoldOrange};
          background-color: ${paleyellow};
        `
      case RepaymentPolicyStatus.FINISHED:
      case RepaymentPolicyStatus.TERMINATED:
      default:
        return css`
          color: ${midGray};
          background-color: ${lightgreye3};
        `
    }
  }}
  & > div {
    color: inherit;
  }
`
